import React from "react";

export default function Border({ children }) {
  return <div style={{ border: "1px solid #E3E9EF" }}>{children}</div>;
}
